import { IEffect } from '../../actions/effects/IEffect';
import { GameScene } from '../../GameScene';
import { blockViewAssets } from '../../util/blockTools';
import { FlowerFidgetBlockEntity } from './FlowerFidgetBlockEntity';
import { playSpineAnimation } from 'src/lib/ui/utils/spine';
import { randomRange } from '../../../odie';
import { app } from '../../app';
import gsap from 'gsap';
import { getGoals } from 'src/game/scenes/Match2Scene';
import { getRelativeOffset } from '@play-co/timestep-core/ui';
import { config } from '../../defs/config';
import MotionPathPlugin from 'gsap/MotionPathPlugin';

gsap.registerPlugin(MotionPathPlugin);

export class FlowerFidgetBlockEffect implements IEffect {
  private readonly scene: GameScene;

  constructor(scene: GameScene) {
    this.scene = scene;
  }

  public static assets() {
    return blockViewAssets('flowerFidget');
  }

  public async execute() {
    //
  }

  public async playHitAnimation(entity: FlowerFidgetBlockEntity) {
    this.scene.view2d.setEntityLayer(entity, 'foreground');
    await entity.c.blockFlowerFidget.view?.playHitAnimation();
    this.scene.view2d.setEntityLayer(entity, 'default');
  }

  public async playFlyAnimation(entity: FlowerFidgetBlockEntity) {
    const duration = randomRange(0.6, 0.8);
    const goals = getGoals();
    const target = goals?.getGoal('flowerFidget');
    const spine = entity.c.blockFlowerFidget.view?.spine;
    // Goals and target goal are required to this animation
    if (!goals || !target || !spine) return;

    goals.addSubview(spine);
    playSpineAnimation(spine, { animation: 'flyspin', loop: true });
    app.sound.play('puzzle-roulette');
    app.sound.play('puzzle-lock-destroy');

    const goalsOffset = getRelativeOffset(entity.c.view2d.view.view, goals);
    const targetOffset = getRelativeOffset(target, goals);

    const fromX = spine.style.x + goalsOffset.x + config.tile.size * 0.5;
    const fromY = spine.style.y + goalsOffset.y + config.tile.size * 0.5;
    const toX = targetOffset.x + target.style.width * 0.5;
    const toY = targetOffset.y + target.style.height * 0.5;

    spine.style.x = fromX;
    spine.style.y = fromY;
    spine.style.zIndex = 10; // Make it in front of target icon

    goals.addSubview(spine);

    const scaleUp = { scale: 1 };
    const scaleToGoal = { scale: 0.2 };

    gsap.to(spine.style, {
      ...scaleUp,
      duration: duration * 0.3,
      ease: 'sine.out',
    });

    gsap.to(spine.style, {
      ...scaleToGoal,
      duration: duration * 0.7,
      ease: 'sine.in',
      delay: duration * 0.3,
    });

    await gsap.to(spine.style, {
      motionPath: {
        type: 'soft',
        path: [
          {
            x: fromX + randomRange(-200, 200),
            y: fromY + randomRange(-200, -100),
          },
          { x: toX, y: toY },
        ],
        curviness: 2,
      },
      duration,
      ease: 'linear',
    });

    spine.state.clearTracks();
    spine.removeFromSuperview();
  }
}
